import { __ } from '@wordpress/i18n';
import { createContext, FunctionComponent, ComponentChildren } from 'preact';
import { useReducer } from 'preact/hooks';
import { Country, Region } from '../../../types';

type FilterState = {
	region: Region;
	programs: string[];
	legacyPrograms: boolean;
	activeCountry: Country;
};

type Action = {
	type: 'SET_REGION' | 'SET_PROGRAMS' | 'SET_LEGACY_PROGRAMS' | 'SET_ACTIVE_COUNTRY' | 'RESET';
	payload?: any;
};

type AppContextProps = {
	filterContext: [ FilterState, ( action: Action ) => void ];
};

type AppContextProviderProps = {
	children: ComponentChildren;
};

// Create new context.
export const AppContext = createContext<AppContextProps | null>( null );

// Initial state and reset objects.
export const emptyCountry = {
	name: '',
	post_id: 0,
};

export const emptyRegion = {
	name: __( 'Regions', 'tcc-map' ),
	slug: '',
	term_id: 0,
};

// Create Provider.
export const AppContextProvider: FunctionComponent<AppContextProviderProps> = ( { children } ) => {
	// Initial filter state.
	const initialFilterState: FilterState = {
		region: emptyRegion,
		programs: [],
		legacyPrograms: false,
		activeCountry: emptyCountry,
	};

	const reducer = ( state: FilterState, action: Action ): FilterState => {
		switch ( action.type ) {
			case 'SET_REGION':
				return { ...state, region: action.payload };
			case 'SET_PROGRAMS':
				return { ...state, programs: action.payload };
			case 'SET_LEGACY_PROGRAMS':
				return { ...state, legacyPrograms: action.payload };
			case 'SET_ACTIVE_COUNTRY':
				return { ...state, activeCountry: action.payload };
			case 'RESET':
				return initialFilterState;
			default:
				return state;
		}
	};

	const [ state, dispatch ] = useReducer( reducer, initialFilterState );

	return (
		<AppContext.Provider value={ { filterContext: [ state, dispatch ] } }>
			{ children }
		</AppContext.Provider>
	);
};
